import { Component } from '@angular/core';

@Component({
    selector: 'app-webinar-interested-individuals',
    templateUrl: './webinar-interested-individuals.component.html',
    styleUrls: ['webinar-interested-individuals.component.scss'],
    standalone: false
})
export class WebinarInterestedIndividualsComponent {
    public get webinarScheduleTitle(): string {
        return 'interested-individual-webinar-schedule-title';
    }

    public get webinarScheduleText(): string {
        return 'interested-individual-webinar-schedule-text';
    }
}
